import { Button } from '@travelnest/merlin.button';
import { Modal } from '@travelnest/merlin.modal';
import theme from '@travelnest/merlin.theme';
import React from 'react';
import { useAutoSavePromotion, useCustomerChannels, usePropertyPromotions } from '../../../../view/helpers/hooks';
import { Character } from '../../../constants';
import { Paragraph } from '../../paragraph/Paragraph';
import { PromotionsChannelList } from '../../promotions-list/PromotionsList';
import { buildChannelPromotions } from '../helpers';

interface IPropertyShellTypeStepProps {
	onRequestNext: () => any;
	onRequestPrevious: () => any;
	onRequestClose: () => any;
	ownerId: string;
	propertyId: number;
}

export const PropertyShellPromotionStep: React.FC<
	IPropertyShellTypeStepProps
> = (props) => {
	const { propertyId, ownerId } = props;
	const [promotions] = usePropertyPromotions(propertyId);
	const [channels] = useCustomerChannels(ownerId);
	const filteredPromotions = buildChannelPromotions(promotions, channels);
	const [updater] = useAutoSavePromotion(propertyId);

	return (
		<Modal
			title="Add a new property"
			onRequestClose={props.onRequestClose}
			shouldCloseOnOverlayClick={false}
			actionLHS={
				<Button
					onClick={props.onRequestPrevious}
					bgColor={theme.colours.background.default}
					color={theme.colours.text.black}
					className="travelnest-modal__button-align"
				>
					<span className="travelnest-modal__icon">
						{Character.Left}
					</span>
					<span>Previous</span>
				</Button>
			}
			actionRHS={
				<Button
					onClick={() => props.onRequestNext()}
					bgColor={theme.colours.success.primary}
					color={theme.colours.text.white}
					hoverColor={theme.colours.success.primary}
					className="travelnest-modal__button-align"
				>
					<span>Done</span>
					<span className="travelnest-modal__icon">
						{Character.Right}
					</span>
				</Button>
			}
		>
			<div>
				<h3>Promotions</h3>
				<Paragraph>
					Promotions are a great way to attract more guests and boost
					your bookings. We recommend opting in to one or more of our
					channel promotions to fill your booking availability and
					increase your visibility.
				</Paragraph>
				{filteredPromotions.length > 0 ? filteredPromotions.map((channel) =>
					<PromotionsChannelList
						channelPromotion={channel}
						onSelectPromotion={updater}
					/>
				) : <Paragraph>Sorry, No Promotions available for your selected channels.</Paragraph>}
			</div>
		</Modal>
	);
};
